import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataZXXBMICZYFP/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataZXXBMICZYFP/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataZXXBMICZYFP/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataZXXBMICZYFP/update/batch',
    method: 'POST',
    data})
}

   